export enum ChainingPatientServiceStatus {
    pending = 'pending',
    validated = 'validated',
    billed = 'billed'
}
